// extracted by mini-css-extract-plugin
export default {"container":"style_container__NdLVm","children":"style_children__GDh0B","title":"style_title__sOjYN","divider":"style_divider__A2V2L","formFooter":"style_formFooter__ni7L5"};